// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderEditableAvatar-moduleEntityProfileHeaderEditableAvatar__MNmfl";
var _2 = "EntityProfileHeaderEditableAvatar-moduleaddPhotoHoverLayer__dM5iU";
var _3 = "EntityProfileHeaderEditableAvatar-moduleavatar__LdzQZ EntityProfileHeaderStaticAvatar-moduleEntityProfileHeaderStaticAvatar__neeE2 EntityProfileHeaderEditableAvatar-moduleavatarButton__SVa4W";
var _4 = "EntityProfileHeaderEditableAvatar-moduleavatarButton__SVa4W";
var _5 = "EntityProfileHeaderEditableAvatar-moduleselect__Lj8Os Select-moduleSelect__MROu3";
export { _1 as "EntityProfileHeaderEditableAvatar", _2 as "addPhotoHoverLayer", _3 as "avatar", _4 as "avatarButton", _5 as "select" }
